// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"753715be","699":"952577f9"}[chunkId] + ".chunk.js";
};